import {FC} from 'react'
import { convertUTCToLocal } from '../../Functional'

interface DateAndTimeCellProps {
  row: any
  classNames?: string
}

const FullDateAndTimeCell: FC<DateAndTimeCellProps> = ({row, classNames}) => {
  return (
    row?.original?.created_at && (
      <div className={`d-flex flex-column ${classNames}`}>
        <div className='manage-title-truncate'>
          {convertUTCToLocal(row?.original?.created_at, 'DD MMM YYYY').toLocaleString()},{' '}
          {convertUTCToLocal(row?.original?.created_at, 'hh:mm A').toLocaleString()}
        </div>
      </div>
    )
  )
}

export {FullDateAndTimeCell}
